import { memo, useState } from 'react';

// eslint-disable-next-line frontbucket-patterns/no-new-emotion-styled
import styled from '@emotion/styled';

import Button from '@atlaskit/button/new';
import { Popup } from '@atlaskit/popup';
import { Box, xcss } from '@atlaskit/primitives';
import { SimpleTag, TagColor } from '@atlaskit/tag';
import TagGroup from '@atlaskit/tag-group';
import { token } from '@atlaskit/tokens';

type Props = {
  customProperties?: Array<{ key: string; value: string }>;
  index: number | string;
};

const popupContentStyles = xcss({
  padding: 'space.200',
  maxWidth: '300px',
  maxHeight: '400px',
  overflowY: 'auto',
});

const ButtonWrapper = styled.div({
  '> button': {
    padding: token('space.050'),
    height: token('space.250'),
    alignItems: 'center',
    margin: token('space.050'),
  },
});

const TAG_COLOR: TagColor = 'purple';

const TestCaseTags = ({ customProperties, index }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const tagStrings =
    customProperties?.map(({ key, value }) => `${key}:${value}`) ?? [];

  const popupContent = (
    <Box xcss={popupContentStyles}>
      <TagGroup>
        {tagStrings.map((tag, i) => (
          <SimpleTag key={`tag-${index}-${i}`} text={tag} color={TAG_COLOR} />
        ))}
      </TagGroup>
    </Box>
  );

  return (
    <TagGroup>
      {tagStrings.length <= 2 &&
        tagStrings.map((tag, i) => (
          <SimpleTag text={tag} key={i} color={TAG_COLOR} />
        ))}
      {tagStrings.length > 2 ? (
        <>
          {tagStrings.slice(0, 2).map((tag, i) => (
            <SimpleTag text={tag} key={i} color={TAG_COLOR} />
          ))}
          <Popup
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            placement="bottom-start"
            content={() => popupContent}
            trigger={triggerProps => (
              <ButtonWrapper>
                <Button
                  name={`tags-popup-${index}`}
                  {...triggerProps}
                  isSelected={isOpen}
                  onClick={() => setIsOpen(!isOpen)}
                  spacing="compact"
                >
                  ...
                </Button>
              </ButtonWrapper>
            )}
          />
        </>
      ) : null}
    </TagGroup>
  );
};

// eslint-disable-next-line import/no-default-export
export default memo(TestCaseTags);
